import TrainingText from './TrainingText';

export default TrainingText;
